import gql from "graphql-tag";

export const MY_TAX_CREATE_COMBINED_DECLARATION = gql`
  mutation createTaxDeclarationCombined(
    $dateOfDeclaration: Date!
    $isEligibleTwo: Boolean!
    $isEligibleThree: Boolean!
    $isEligible: Boolean!
    $dependents: [TaxDeclarationCombinedDependentInput]
    $applyAlone: Boolean!
    $applyTogether: Boolean!
    $noRequestRelief: Boolean!
    $taxReliefAmount: Float!
    $taxReliefNumberOfChild: Float!
    $spouseName: String!
    $spouseTaxNumber: String!
    $spouseEmployerName: String!
    $spouseEmployerTaxNumber: String!
  ) {
    createTaxDeclarationCombined(
      dateOfDeclaration: $dateOfDeclaration
      isEligibleTwo: $isEligibleTwo
      isEligibleThree: $isEligibleThree
      isEligible: $isEligible
      dependents: $dependents
      applyAlone: $applyAlone
      applyTogether: $applyTogether
      noRequestRelief: $noRequestRelief
      taxReliefAmount: $taxReliefAmount
      taxReliefNumberOfChild: $taxReliefNumberOfChild
      spouseName: $spouseName
      spouseTaxNumber: $spouseTaxNumber
      spouseEmployerName: $spouseEmployerName
      spouseEmployerTaxNumber: $spouseEmployerTaxNumber
    ) {
      result
      messages
      tableId
    }
  }
`;
